import { styled } from '@mui/material';
export const StyledComponent = styled;
